// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main {
  font-family: var(--tertiary-font);
}

.StyleCatalogue_content__nm3O\\+ {
  padding: 2rem 5rem;
  margin-top: 13rem;
}
@media only screen and (max-width: 43.75em) {
  .StyleCatalogue_content__nm3O\\+ {
    margin-top: 17rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .StyleCatalogue_content__nm3O\\+ {
    padding: 2rem;
  }
}

.StyleCatalogue_contact__XWbxg {
  display: flex;
  justify-content: center;
}
.StyleCatalogue_contact__XWbxg > * {
  width: 55vw;
}

h3 {
  font-weight: 700;
  font-size: large;
}

.StyleCatalogue_title__eDHX2 {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  gap: 2rem;
  position: fixed;
  top: 0;
  background-color: var(--color-white);
}
.StyleCatalogue_title_img__Bp9wD {
  height: 5rem;
}

.StyleCatalogue_footer2__c8FCb {
  background-color: var(--color-white);
  color: var(--color-dark);
  padding: 2rem 5rem;
  margin-top: 2rem;
  border-top: 1px solid var(--color-grey);
}
@media only screen and (max-width: 31.25em) {
  .StyleCatalogue_footer2__c8FCb {
    padding: 2rem;
  }
}
.StyleCatalogue_footer2__item__jb46V {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
@media only screen and (max-width: 37.5em) {
  .StyleCatalogue_footer2__item__jb46V {
    flex-direction: column;
    align-items: center;
  }
}
.StyleCatalogue_footer2__item__jb46V img {
  width: 20rem;
  margin-bottom: 3rem;
}
.StyleCatalogue_footer2__socials__2vPMF {
  display: flex;
  font-size: 2.5rem;
  gap: 1rem;
}
.StyleCatalogue_footer2_list__B-\\+OC {
  text-decoration: none;
  padding: 1rem 0;
  color: var(--color-dark);
  cursor: pointer;
}
.StyleCatalogue_footer2_list__B-\\+OC:hover {
  color: var(--color-fash-primary-2);
}
.StyleCatalogue_footer2_copyright__bpYWz {
  display: flex;
  justify-content: center;
  width: 100%;
  font-weight: 400;
  margin-top: 3rem;
  padding: 3rem 0;
  font-size: var(--default-font-small);
}
.StyleCatalogue_footer2_copyright__link__30P6L {
  cursor: pointer;
}
.StyleCatalogue_footer2_copyright__link__30P6L:hover {
  color: var(--color-fash-primary-2);
}
.StyleCatalogue_footer2__logo__hpiff {
  width: 10rem;
  height: 8rem;
}
.StyleCatalogue_footer2__logSoc__snfG0 {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.StyleCatalogue_aside__ans__Uk4Jx {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  border-bottom: 1px solid var(--color-grey);
  gap: 2rem;
  padding: 1rem 0;
}

.StyleCatalogue_signs__6f1RO {
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
}
.StyleCatalogue_signs__active__Gz1JN {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: 700;
  color: var(--color-fash-primary-2);
  cursor: pointer;
}

.StyleCatalogue_icon__O3D6A {
  color: var(--color-fash-primary-2);
}

.StyleCatalogue_about__z55u- {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 2rem;
  align-items: center;
  padding: 0 7%;
}
@media only screen and (max-width: 62.5em) {
  .StyleCatalogue_about__z55u- {
    padding: 0 3%;
  }
}
@media only screen and (max-width: 50em) {
  .StyleCatalogue_about__z55u- {
    padding: 0;
    grid-template-columns: 100%;
  }
}
.StyleCatalogue_about__z55u- img {
  max-height: 60rem;
}
@media only screen and (max-width: 50em) {
  .StyleCatalogue_about__z55u- img {
    max-height: fit-content;
    width: 100%;
  }
}
.StyleCatalogue_about__text__uXQVB {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.StyleCatalogue_sizeSwitch__hlC5\\+ {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 1rem;
  cursor: pointer;
}
.StyleCatalogue_sizeSwitch__hlC5\\+ > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.StyleCatalogue_sizeSwitch__inches__1z8mP {
  background-color: var(--color-dark);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.StyleCatalogue_sizeSwitch__inches_b__MB1mI {
  border: 1px solid var(--color-dark);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.StyleCatalogue_sizeSwitch__cm__PoXiS {
  background-color: var(--color-dark);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.StyleCatalogue_sizeSwitch__cm_b__Zl2yq {
  border: 1px solid var(--color-dark);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Catalogue/StyleCatalogue.module.scss"],"names":[],"mappings":"AAEA;EACC,iCAAA;AADD;;AAIA;EACC,kBAAA;EACA,iBAAA;AADD;AAGC;EAJD;IAKE,iBAAA;EAAA;AACF;AAEC;EARD;IASE,aAAA;EACA;AACF;;AAEA;EACC,aAAA;EACA,uBAAA;AACD;AACC;EACC,WAAA;AACF;;AAGA;EACC,gBAAA;EACA,gBAAA;AAAD;;AAGA;EACC,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,MAAA;EACA,oCAAA;AAAD;AAEC;EACC,YAAA;AAAF;;AAIA;EACC,oCAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;AADD;AAGC;EAPD;IAQE,aAAA;EAAA;AACF;AAEC;EACC,aAAA;EACA,6BAAA;EACA,WAAA;AAAF;AAEE;EALD;IAME,sBAAA;IACA,mBAAA;EACD;AACF;AACE;EACC,YAAA;EACA,mBAAA;AACH;AAGC;EACC,aAAA;EACA,iBAAA;EACA,SAAA;AADF;AAIC;EACC,qBAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;AAFF;AAIE;EACC,kCAAA;AAFH;AAMC;EACC,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;AAJF;AAME;EACC,eAAA;AAJH;AAMG;EACC,kCAAA;AAJJ;AASC;EACC,YAAA;EACA,YAAA;AAPF;AAUC;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AARF;;AAcC;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,0CAAA;EACA,SAAA;EACA,eAAA;AAXF;;AAeA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAZD;AAcC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kCAAA;EACA,eAAA;AAZF;;AAgBA;EACC,kCAAA;AAbD;;AAgBA;EACC,aAAA;EACA,sCAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;AAbD;AAeC;EAPD;IAQE,aAAA;EAZA;AACF;AAeC;EAZD;IAaE,UAAA;IACA,2BAAA;EAZA;AACF;AAeC;EACC,iBAAA;AAbF;AAeE;EAHD;IAIE,uBAAA;IACA,WAAA;EAZD;AACF;AAeC;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAbF;;AAiBA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAfD;AAiBC;EACC,sBAAA;EACA,kBAAA;AAfF;AAkBC;EACC,mCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAhBF;AAkBE;EACC,mCAAA;EACA,4BAAA;EACA,oBAAA;AAhBH;AAoBC;EAEC,mCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAnBF;AAqBE;EACC,mCAAA;EACA,4BAAA;EACA,oBAAA;AAnBH","sourcesContent":["@import '../variables/breakpoints';\n\nmain {\n\tfont-family: var(--tertiary-font);\n}\n\n.content {\n\tpadding: 2rem 5rem;\n\tmargin-top: 13rem;\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tmargin-top: 17rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tpadding: 2rem;\n\t}\n}\n\n.contact {\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t&>* {\n\t\twidth: 55vw;\n\t}\n}\n\nh3 {\n\tfont-weight: 700;\n\tfont-size: large;\n}\n\n.title {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 2rem;\n\tgap: 2rem;\n\tposition: fixed;\n\ttop: 0;\n\tbackground-color: var(--color-white);\n\n\t&_img {\n\t\theight: 5rem;\n\t}\n}\n\n.footer2 {\n\tbackground-color: var(--color-white);\n\tcolor: var(--color-dark);\n\tpadding: 2rem 5rem;\n\tmargin-top: 2rem;\n\tborder-top: 1px solid var(--color-grey);\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tpadding: 2rem;\n\t}\n\n\t&__item {\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\n\t\timg {\n\t\t\twidth: 20rem;\n\t\t\tmargin-bottom: 3rem;\n\t\t}\n\t}\n\n\t&__socials {\n\t\tdisplay: flex;\n\t\tfont-size: 2.5rem;\n\t\tgap: 1rem;\n\t}\n\n\t&_list {\n\t\ttext-decoration: none;\n\t\tpadding: 1rem 0;\n\t\tcolor: var(--color-dark);\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tcolor: var(--color-fash-primary-2);\n\t\t}\n\t}\n\n\t&_copyright {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\tfont-weight: 400;\n\t\tmargin-top: 3rem;\n\t\tpadding: 3rem 0;\n\t\tfont-size: var(--default-font-small);\n\n\t\t&__link {\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--color-fash-primary-2);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__logo {\n\t\twidth: 10rem;\n\t\theight: 8rem;\n\t}\n\n\t&__logSoc {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\t}\n\n}\n\n.aside {\n\t&__ans {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-top: 2rem;\n\t\tborder-bottom: 1px solid var(--color-grey);\n\t\tgap: 2rem;\n\t\tpadding: 1rem 0;\n\t}\n}\n\n.signs {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 1rem;\n\tcursor: pointer;\n\n\t&__active {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 1rem;\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-fash-primary-2);\n\t\tcursor: pointer;\n\t}\n}\n\n.icon {\n\tcolor: var(--color-fash-primary-2);\n}\n\n.about {\n\tdisplay: grid;\n\tgrid-template-columns: max-content 1fr;\n\tgap: 2rem;\n\talign-items: center;\n\tpadding: 0 7%;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tpadding: 0 3%;\n\n\t}\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tpadding: 0;\n\t\tgrid-template-columns: 100%;\n\n\t}\n\n\timg {\n\t\tmax-height: 60rem;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tmax-height: fit-content;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&__text {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n}\n\n.sizeSwitch {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 1rem;\n\tcursor: pointer;\n\n\t&>* {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__inches {\n\t\tbackground-color: var(--color-dark);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-dark);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__cm {\n\n\t\tbackground-color: var(--color-dark);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-dark);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `StyleCatalogue_content__nm3O+`,
	"contact": `StyleCatalogue_contact__XWbxg`,
	"title": `StyleCatalogue_title__eDHX2`,
	"title_img": `StyleCatalogue_title_img__Bp9wD`,
	"footer2": `StyleCatalogue_footer2__c8FCb`,
	"footer2__item": `StyleCatalogue_footer2__item__jb46V`,
	"footer2__socials": `StyleCatalogue_footer2__socials__2vPMF`,
	"footer2_list": `StyleCatalogue_footer2_list__B-+OC`,
	"footer2_copyright": `StyleCatalogue_footer2_copyright__bpYWz`,
	"footer2_copyright__link": `StyleCatalogue_footer2_copyright__link__30P6L`,
	"footer2__logo": `StyleCatalogue_footer2__logo__hpiff`,
	"footer2__logSoc": `StyleCatalogue_footer2__logSoc__snfG0`,
	"aside__ans": `StyleCatalogue_aside__ans__Uk4Jx`,
	"signs": `StyleCatalogue_signs__6f1RO`,
	"signs__active": `StyleCatalogue_signs__active__Gz1JN`,
	"icon": `StyleCatalogue_icon__O3D6A`,
	"about": `StyleCatalogue_about__z55u-`,
	"about__text": `StyleCatalogue_about__text__uXQVB`,
	"sizeSwitch": `StyleCatalogue_sizeSwitch__hlC5+`,
	"sizeSwitch__inches": `StyleCatalogue_sizeSwitch__inches__1z8mP`,
	"sizeSwitch__inches_b": `StyleCatalogue_sizeSwitch__inches_b__MB1mI`,
	"sizeSwitch__cm": `StyleCatalogue_sizeSwitch__cm__PoXiS`,
	"sizeSwitch__cm_b": `StyleCatalogue_sizeSwitch__cm_b__Zl2yq`
};
export default ___CSS_LOADER_EXPORT___;
